var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7062 7.30529C14.5187 7.11782 14.2644 7.0125 13.9992 7.0125C13.7341 7.0125 13.4798 7.11782 13.2922 7.30529L9.99924 10.5983L6.70623 7.30529C6.61399 7.20978 6.50364 7.1336 6.38164 7.08119C6.25963 7.02878 6.12841 7.00119 5.99564 7.00004C5.86285 6.99888 5.73118 7.02419 5.60828 7.07447C5.48538 7.12475 5.37373 7.199 5.27984 7.29289C5.18595 7.38679 5.11169 7.49844 5.06141 7.62133C5.01113 7.74423 4.98583 7.87591 4.98698 8.00869C4.98814 8.14147 5.01572 8.27269 5.06813 8.39469C5.12054 8.5167 5.19672 8.62704 5.29223 8.71929L9.29224 12.7193C9.47976 12.9068 9.73407 13.0121 9.99924 13.0121C10.2644 13.0121 10.5187 12.9068 10.7062 12.7193L14.7062 8.71929C14.8937 8.53176 14.999 8.27745 14.999 8.01229C14.999 7.74712 14.8937 7.49282 14.7062 7.30529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownWhite);
export default __webpack_public_path__ + "static/media/chevronDownWhite.d3a5224edf5533bc2418b12dc5893c78.svg";
export { ForwardRef as ReactComponent };